import { render, staticRenderFns } from "./DashboardV1Component.vue?vue&type=template&id=bf6365da"
import script from "./DashboardV1Component.vue?vue&type=script&lang=js"
export * from "./DashboardV1Component.vue?vue&type=script&lang=js"
import style0 from "./DashboardV1Component.vue?vue&type=style&index=0&id=bf6365da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports